"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var THREE = require("../../../../externals/three");
var MessagingConstants_1 = __importDefault(require("../../../../shared/constants/MessagingConstants"));
var MessagePrototype_1 = __importDefault(require("../../../../shared/messages/MessagePrototype"));
var GlobalUtils_js_1 = __importDefault(require("../../../../shared/util/GlobalUtils.js"));
var detect_it_1 = __importDefault(require("detect-it"));
var HooksAndNotifiers_1 = require("../../helpers/HooksAndNotifiers");
var CameraHooksAndNotifiers_1 = require("./hooks/CameraHooksAndNotifiers");
var StateDashboard_1 = require("../../../../modules/shapediver-state-dashboard/StateDashboard");
var BaseCameraHandler = /** @class */ (function () {
    // #endregion Properties (14)
    // #region Constructors (1)
    function BaseCameraHandler(settings, _handlers) {
        this._handlers = _handlers;
        // #region Properties (14)
        this._active = true;
        this._cameraMatrix = new THREE.Matrix4();
        this._eventListenerCounter = 0;
        this.CAMERA_MOVING_ID = 'cameraMoving';
        this.TWEEN_ID = 'cameraMoving';
        this._detect_it = detect_it_1.default;
        this._globalUtils = GlobalUtils_js_1.default;
        this._settings = settings.settings;
        this._geometryNode = settings.geometryNode;
        this._container = settings.container;
        this._sceneBS = new THREE.Sphere(new THREE.Vector3(), 1.0);
        this._firstTimeVisible = StateDashboard_1.StateDashboardLibrary.getInstance(_handlers.threeDManager.viewerApi.getSetting('viewerRuntimeId')).firstTimeVisible;
        HooksAndNotifiers_1.registerHooksAndNotifiers(this, this._settings, CameraHooksAndNotifiers_1.CameraHooks, CameraHooksAndNotifiers_1.CameraNotifiers);
    }
    Object.defineProperty(BaseCameraHandler.prototype, "camera", {
        // #endregion Constructors (1)
        // #region Public Accessors (1)
        get: function () {
            return this._camera;
        },
        enumerable: true,
        configurable: true
    });
    // #endregion Public Accessors (1)
    // #region Public Methods (8)
    BaseCameraHandler.prototype.decreaseEventListenerCounter = function () {
        this._eventListenerCounter--;
    };
    BaseCameraHandler.prototype.destroy = function () {
        // do something :)
    };
    BaseCameraHandler.prototype.getPositionAndTarget = function () {
        return {
            position: this._globalUtils.deepCopy(this._cameraControls.position),
            target: this._globalUtils.deepCopy(this._cameraControls.target)
        };
    };
    BaseCameraHandler.prototype.increaseEventListenerCounter = function () {
        this._eventListenerCounter++;
    };
    BaseCameraHandler.prototype.pause = function () {
        this._active = false;
        this._cameraControls.enabled = false;
    };
    BaseCameraHandler.prototype.resume = function () {
        this._active = true;
        this._camera.updateProjectionMatrix();
        this._cameraControls.enabled = this._settings.getSetting('enableCameraControls');
        this._cameraControls.reset();
    };
    BaseCameraHandler.prototype.setViewAndProjectionMatrix = function (viewMatrix, projectionMatrix) {
        // update camera view matrix
        this._cameraMatrix.getInverse(viewMatrix);
        this._cameraMatrix.decompose(this._camera.position, this._camera.quaternion, this._camera.scale);
        // update camera projection matrix
        this._camera.projectionMatrix.copy(projectionMatrix);
    };
    BaseCameraHandler.prototype.updateCameraControls = function (time) {
        // no update if orbit controls are disable (important for AR)
        if (!this._settings.getSetting('enableCameraControls'))
            return;
        this._cameraControls.update(time);
        this._handlers.renderingHandler.unregisterForContinuousRendering(this.CAMERA_MOVING_ID);
        if (this._cameraControls.isMoving())
            this._handlers.renderingHandler.registerForContinuousRendering(this.CAMERA_MOVING_ID, false);
    };
    // #endregion Public Abstract Methods (9)
    // #region Protected Methods (1)
    BaseCameraHandler.prototype.cameraMovementEventDispatch = function (moved, wasMoving, duration) {
        // if there is no event listener
        if (this._eventListenerCounter === 0)
            return;
        var type;
        if (moved) {
            if (wasMoving) {
                type = MessagingConstants_1.default.messageTopics.SCENE_CAMERA_MOVE;
            }
            else {
                duration = 0;
                type = MessagingConstants_1.default.messageTopics.SCENE_CAMERA_START;
            }
        }
        else {
            if (wasMoving) {
                type = MessagingConstants_1.default.messageTopics.SCENE_CAMERA_END;
            }
        }
        var cameraDefinition = {
            position: this._cameraControls.position,
            target: this._cameraControls.target
        };
        var msg_obj = { type: type, cameraDefinition: cameraDefinition, duration: duration };
        var m = new MessagePrototype_1.default(MessagingConstants_1.default.messageDataTypes.SCENE_CAMERA, msg_obj);
        this._handlers.threeDManager.message(type, m);
    };
    return BaseCameraHandler;
}());
exports.BaseCameraHandler = BaseCameraHandler;
